export default __webpack_public_path__ + "static/media/bg.c3d4d544.jpg";